import Action from "../../classes/Action";
import Step from "../../classes/scenarioElements/Step";
import { StepUIData } from "../../interfaces/UITemplateData";
import store, { StoreActions } from '../../state/store';

export default class SaveSlideToTemplate extends Action
{
	constructor(step: Step)
	{
		const newSlide: StepUIData = store.getState().uiModule.ui[step.id];
		const oldSlide: StepUIData = { ...store.getState().uiModule.slideMaster[newSlide.slide ?? ''] };

		super(
			[step, newSlide, oldSlide.name],
			[newSlide.slide, step.id, oldSlide, newSlide],
			`Save Slide to Template`,
			[newSlide, oldSlide]
		);
	}

	do(step: Step, newSlide: StepUIData, slideName: string)
	{
		const newSlideJson = JSON.stringify(newSlide);
		const slideTemplate: StepUIData = JSON.parse(newSlideJson);

		slideTemplate.name = slideName;
		slideTemplate.type = 'slide';

		delete slideTemplate.synced;
		delete slideTemplate.slide;

		for (const [subCompKey, subComp] of Object.entries(slideTemplate[slideTemplate.active]))
		{
			for (const [propKey, prop] of Object.entries(subComp))
			{
				if (prop.changed)
				{
					delete slideTemplate[slideTemplate.active][subCompKey][propKey].changed;
				}
			}
		}
		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: newSlide.slide, content: { ...slideTemplate }, sourceStepId: step.id }));
	}

	undo(slide: string, stepId: string, oldSlide: StepUIData, oldUi: StepUIData)
	{
		store.dispatch(StoreActions.ui.setSlideFromCopy({ slide: slide, content: { ...oldSlide } }));
		store.dispatch(StoreActions.ui.setFromCopy({ stepId: stepId, content: { ...oldUi } }));
	}

	verify(newSlide: StepUIData, oldSlide: StepUIData)
	{
		if (!newSlide) return false;
		if (!oldSlide) return false;
		return true;
	}
}
